// Display formatting for pricing-adjustment factor names in the rate detail panel.
//
// Two kinds of key reach this function:
//
//   * lender_terms v1 responses carry a display name the backend already
//     formatted, e.g. "Credit Score / LTV" or "Impound Waiver".
//   * The legacy pricing path keys adjustments by Go struct field name, via
//     reflection in calculation.GetAdjustmentSum:
//         finalAdj.AppliedAdjustments[typeOfS.Field(i).Name] = p
//     which yields camel case such as "FicoLTVAdjustment".
//
// Only the second kind needs splitting. The signal for "already a display
// name" is an existing space: backend display names have one, Go field names
// cannot. An earlier version tested for the absence of "_" and ":" instead,
// which also matched every camel-case field name and so left them unsplit.
export function formatAdjustmentName(str) {
  const raw = String(str || "");
  if (raw.includes(" ")) return raw;
  return raw
    .replace(/_/g, " ")
    .replace(/([A-Z])(?=[A-Z][a-z])|([a-z])(?=[A-Z])/g, "$1$2 ")
    .replace(/(^|:\s*)([a-z])/g, (match, prefix, letter) => `${prefix}${letter.toUpperCase()}`)
    .trim();
}
